// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"106":"music","555":"insta","596":"404","851":"tour"}[chunkId] + "." + {"106":"c9da9f25","555":"189c385f","596":"5b4ed5f7","851":"57f40e6a"}[chunkId] + ".js";
};